import { IDatePickerStrings } from '@fluentui/react/lib/DatePicker';

export const datePickerStrings: IDatePickerStrings = {
    months: [
        'Jänner',
        'Februar',
        'März',
        'April',
        'Mai',
        'Juni',
        'Juli',
        'August',
        'September',
        'Oktober',
        'November',
        'Dezember',
    ],

    shortMonths: ['Jan', 'Feb', 'Mar', 'Apr', 'Mai', 'Jun', 'Jul', 'Aug', 'Sep', 'Okt', 'Nov', 'Dez'],

    days: ['Sonntag', 'Monday', 'Dienstag', 'Mittwoch', 'Donnerstag', 'Freitag', 'Samstag'],

    shortDays: ['So', 'Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'],

    goToToday: 'heute',
    prevMonthAriaLabel: 'Vorheriger Monat',
    nextMonthAriaLabel: 'Nächster Monat',
    prevYearAriaLabel: 'Vorheriges Jahr',
    nextYearAriaLabel: 'Nächstes Jahr',
    closeButtonAriaLabel: 'Schließen',
    monthPickerHeaderAriaLabel: '{0}, Jahr ändern',
    yearPickerHeaderAriaLabel: '{0}, Monat ändern',
};

export const onFormatDate = (date?: Date): string => {
    return !date ? '' : date.getDate() + '.' + (date.getMonth() + 1) + '.' + date.getFullYear();
};
